export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative z-20 border-t border-steam-copper/30 bg-dark-abyss/90 backdrop-blur-md mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-steam text-steam-copper mb-4">TEDDY-KGB</h3>
            <p className="text-gray-iron font-cyber text-sm leading-relaxed">
              Exploring the depths of IT security, one exploit at a time.
              From the shadows of cyberspace to the brass gears of secure systems.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-steam-bronze font-steam mb-4 text-lg">Navigation</h4>
            <ul className="space-y-2 font-cyber text-sm">
              <li>
                <a
                  href="/"
                  className="text-gray-iron hover:text-cyber-blue transition-colors"
                >
                  &gt; Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-gray-iron hover:text-cyber-blue transition-colors"
                >
                  &gt; About
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-iron hover:text-cyber-blue transition-colors"
                >
                  &gt; Archive
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-gray-iron hover:text-cyber-blue transition-colors"
                >
                  &gt; RSS Feed
                </a>
              </li>
            </ul>
          </div>

          {/* Social & Contact */}
          <div>
            <h4 className="text-steam-bronze font-steam mb-4 text-lg">Connect</h4>
            <div className="space-y-3">
              <a
                href="#"
                className="flex items-center gap-2 text-gray-iron hover:text-cyber-pink transition-colors font-cyber text-sm"
              >
                <span className="text-cyber-pink">▸</span> Twitter / X
              </a>
              <a
                href="#"
                className="flex items-center gap-2 text-gray-iron hover:text-cyber-purple transition-colors font-cyber text-sm"
              >
                <span className="text-cyber-purple">▸</span> GitHub
              </a>
              <a
                href="#"
                className="flex items-center gap-2 text-gray-iron hover:text-cyber-green transition-colors font-cyber text-sm"
              >
                <span className="text-cyber-green">▸</span> LinkedIn
              </a>
              <a
                href="mailto:contact@teddy-kgb.com"
                className="flex items-center gap-2 text-gray-iron hover:text-cyber-blue transition-colors font-cyber text-sm"
              >
                <span className="text-cyber-blue">▸</span> Email
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-dark-steel text-center">
          <p className="text-gray-smoke font-cyber text-sm">
            &copy; {currentYear} TEDDY-KGB.COM | All Rights Reserved
          </p>
          <p className="text-gray-smoke font-cyber text-xs mt-2">
            Built with <span className="text-danger-red animate-pulse">♥</span> in the
            digital underground
          </p>
        </div>
      </div>

      {/* Glowing top border */}
      <div className="h-[2px] bg-gradient-to-r from-transparent via-steam-copper to-transparent opacity-50" />
    </footer>
  )
}
